import { Dialog } from "@mui/material";
import React, { PropsWithChildren, useContext } from "react";

import { BoundingBoxesContext, BoundingBoxesContextType } from "context/boundingBoxesContext";

export function FullscreenGroundlightImageQuery({ children }: PropsWithChildren<object>) {
  const { fullScreen, setFullScreen } = useContext(BoundingBoxesContext) as BoundingBoxesContextType;

  return (
    <Dialog
      id="full-screen-groudndlight-image-query"
      open={fullScreen}
      onClose={() => {
        setFullScreen(false);
      }}
      fullScreen
      PaperProps={{
        sx: {
          width: `calc(100% - 80px)`,
          height: `calc(100% - 70px)`,
          background: "transparent",
        },
      }}
    >
      {children}
    </Dialog>
  );
}
